module.exports = __webpack_public_path__ + "static/media/100_new_2024.jpg";